import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PanelDetailsService {
  preOrderDetails;
  constructor() {}

  setPreOrderDetails(details) {
    this.preOrderDetails = details;
  }

  getPreOrderDetails() {
    return this.preOrderDetails;
  }
}
